import React, { useState } from "react";
import { Form } from "react-bootstrap";

interface SelectComponentProps {
  id: string;
  label: string;
  optionAndValue: { [key: string]: string };
  required?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  validator?: (
    value: string,
    isRequired: boolean,
    selectorName: string
  ) => string | null;
}

export const FormSelect: React.FC<SelectComponentProps> = ({
  id,
  label,
  optionAndValue,
  required = false,
  value = "",
  onChange,
  onBlur,
  validator,
}) => {
  const [error, setError] = useState<string | null>(null);

  const validate = (valueToValidate: string) => {
    if (validator) {
      return validator(valueToValidate, required, label);
    }
    return null;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectdValue = e.target.value;
    if (onChange) onChange(selectdValue);
    setError(validate(selectdValue));
  };

  const handleBlur = () => {
    setError(validate(value));
    if (onBlur) onBlur();
  };

  return (
    <Form.Group controlId={id} className="form-group-class">
      <Form.Label>
        <strong>{label}</strong>
      </Form.Label>
      <Form.Control
        as="select"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={Boolean(error)}
        required={required}
      >
        <option value="">--Please choose an option--</option>
        {Object.entries(optionAndValue).map(([key, value], index) => (
          <option key={index} value={value}>
            {key}
          </option>
        ))}
      </Form.Control>

      {error && (
        <Form.Control.Feedback type="invalid">
          <small>{error}</small>
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};
